import React from 'react';
import { LuUpload } from "react-icons/lu";
import { MdOutlineTextSnippet } from "react-icons/md";

export default function AttachmentDropdown({ isOpen, dropdownRef, onUploadClick, onTextContentClick, isUploading }) {
    if (!isOpen) return null;
    
    const styles = {
        dropdownMenu: {
            position: 'absolute',
            top: '100%',
            left: '0',
            backgroundColor: '#27272A',
            border: '1px solid #4A5568',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            minWidth: '250px',
            padding: '8px 0',
            marginTop: '4px',
        },
        dropdownItem: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 16px',
            color: 'white',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            border: 'none',
            backgroundColor: 'transparent',
            width: '100%',
            textAlign: 'left',
            fontSize: '14px',
        },
        dropdownItemHover: {
            backgroundColor: '#4A5568',
        }
    };

    return (
        <div
            ref={dropdownRef}
            style={styles.dropdownMenu}
        >
                <button 
                    style={{...styles.dropdownItem, opacity: isUploading ? 0.6 : 1}}
                    onMouseEnter={(e) => !isUploading && (e.target.style.backgroundColor = styles.dropdownItemHover.backgroundColor)}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!isUploading) {
                            onUploadClick();
                        }
                    }}
                    disabled={isUploading}
                >
                    <LuUpload />
                    {isUploading ? 'Enviando...' : 'Carregar do aparelho'}
                </button>
                
                <button 
                    style={styles.dropdownItem}
                    onMouseEnter={(e) => e.target.style.backgroundColor = styles.dropdownItemHover.backgroundColor}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    onClick={(e) => {
                        e.stopPropagation();
                        onTextContentClick();
                    }}
                >
                    <MdOutlineTextSnippet />
                    Adicionar conteúdo de texto
                </button>
        </div>
    );
};
